import { render, staticRenderFns } from "./ReportsComparativePDF.vue?vue&type=template&id=c38c0b7a&scoped=true&"
import script from "./ReportsComparativePDF.vue?vue&type=script&lang=js&"
export * from "./ReportsComparativePDF.vue?vue&type=script&lang=js&"
import style0 from "./ReportsComparativePDF.vue?vue&type=style&index=0&id=c38c0b7a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38c0b7a",
  null
  
)

export default component.exports